import { render, staticRenderFns } from "./ModalUploadFarm.vue?vue&type=template&id=22ec0980&scoped=true&"
import script from "./ModalUploadFarm.vue?vue&type=script&lang=ts&"
export * from "./ModalUploadFarm.vue?vue&type=script&lang=ts&"
import style0 from "./modal-upload-farm.scss?vue&type=style&index=0&id=22ec0980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec0980",
  null
  
)

export default component.exports